export const PACKAGE_VERSION = "24.1.2"
